$( document ).ready(function() {
  $('.acc__title').click(function(j) {
    
    var dropDown = $(this).closest('.acc__card').find('.acc__panel');
    $(this).closest('.acc').find('.acc__panel').not(dropDown).slideUp();
    
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).closest('.acc').find('.acc__title.active').removeClass('active');
      $(this).addClass('active');
    }
    
    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
  });
  





  function swymForloop(){
    if ($('.product-page--submit-action button#purchase').attr('disabled')){
      //  console.log('disabled');
      $('.product-page--submit-action .additional-checkout-buttons').hide();
    } else {
      // console.log('disabled else');
      $('.product-page--submit-action .additional-checkout-buttons').show();
    }  
  }
  var interval = self.setInterval(function(){swymForloop()},50);


  $(window).scroll(function(){
  
  var scr = $(window).scrollTop();
  if(scr > 100){  
   $('#top-search-wrapper').addClass('expanded itg_search').css({"display":"block","z-index":"5"});
    $('#search-bar--clear').css({"display":"none"});
    $('#top-search-wrapper #search_text').css({"width":"92%"});
  }
  else{
    $('#top-search-wrapper').removeClass('expanded'); 
     $('#search-bar--clear').css({"display":"block"});
    $('#top-search-wrapper #search_text').css({"width":"100%"});
  }
    
  }); 

  
});